var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-button',_vm._b({attrs:{"aria-label":_vm.buttonLabel},on:{"click":function($event){return _vm.onToggle($event)}}},'gl-button',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.buttonLabel)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }